var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankpPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 11,
    height: 11,
    fill: "url(#pattern0_641_450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_450",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_450",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_450",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAcxJREFUWIXtl7FOWzEYhc9xGkYGBhpCEgZEi8SjdKx4hFZVlRdggpERiQjEU7D1TZBoRrhKUKVmR2p8GBAl18L+ry8hWfBmy9/9j/37P74GltxYZVKr93kfHgMQntLPcTG8NJmtnS/w7lyAo/T9rhj+emmeqyRTOAGxDqAlclAJ8e4CQJfAJsCz2DxTQKeztwagPTO0WoV5DPw/ylptAb5xvxUM3WYzYpQxBUx9oxsM3eQzqi+AYq/Up70DISMyKto+hE6l1cjHVxNjqDhDANjo7H4VdQpgw/z4fNqIUn9cDC8dAIgaLDA4ALSfyrmaD7xhcwBAsQ9gvMC4I0p9wLDidnu76xsfnk+w8Oeu+P1xnkwyBf+azXI9VyjBXCYpgN6X6xnxeq7LpAWIpdW4RD3XZdJVEJoQ455el7F2oBcM2CnIZJICFHr61JkCcpl0Cljeziandgoymfe74P0uiN4Frc6nQ5BHT32Kx+Pi+iD11VZv9wjSYQ4TTQHJwFC8XQEKTchmEmdAwX+d7QFEKMBmogIUeLqm9mrE0IReswNu5mEBYIXNCinIZ+ICPCYzvVFRXE2ic58F/M1l4ocQ+IHHR8gtpG9m8JrM0tsDVNzcH4bdbJ0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankpPrice);
export default __webpack_public_path__ + "static/media/rankp_price.86f53b4e5d94d1bc5866b67515d1bce1.svg";
export { ForwardRef as ReactComponent };